import { render, staticRenderFns } from "./TablaSeriesTodos.vue?vue&type=template&id=50c1d6c6&"
import script from "./TablaSeriesTodos.vue?vue&type=script&lang=ts&"
export * from "./TablaSeriesTodos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports